<template>
    <el-dialog width="80%" v-dialog-drag
               title="人员查询"
               :close-on-press-escape="false"
               :before-close="handleClickCancel"
               :close-on-click-modal="false"
               :visible.sync="personnelVisible">
        <el-form size="small"
                 @submit.native.prevent
                 :inline="true">
            <div class="flex_js_wrap">
                <div>
                    <el-form-item>
                        <el-input placeholder="请输入姓名" v-model="keyWord.name"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input placeholder="请输入电话" v-model="keyWord.phone"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input placeholder="请输入邮箱" v-model="keyWord.email"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleClickSearch">搜索</el-button>
                        <el-button @click="handleClickReset">重置</el-button>
                    </el-form-item>
                </div>
                <el-form-item>

                </el-form-item>
            </div>
        </el-form>
        <el-table :data="tableData" border :height="tableHeight" v-loading="loading">
            <el-table-column label="编号" prop="user_id" align="center" width="120"></el-table-column>
            <el-table-column label="姓名" prop="name" align="center"></el-table-column>
            <el-table-column label="头像" prop="wxapp_name" align="center" width="120">
                <template slot-scope="{row}">
                    <img width="80px" :src="row.avatar">
                </template>
            </el-table-column>
            <el-table-column label="联系方式" prop="phone" align="center"></el-table-column>
            <el-table-column label="邮箱" prop="email" align="center"></el-table-column>
            <el-table-column label="性别" prop="gender" align="center"></el-table-column>
            <el-table-column label="所属部门" prop="title" align="center"></el-table-column>
            <el-table-column label="最后登录时间" prop="last_login_time" align="center"></el-table-column>
            <el-table-column label="绑定管理员" align="center" width="100">
                <template slot-scope="{row}">
                    <el-button type="text" @click="handleClickAuth(row.user_id)">绑定/解绑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="mb-15" background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="pagination.pageNum"
                       :page-sizes="pagination.pageSizes"
                       :page-size="pagination.pageSize"
                       :layout="pagination.layout"
                       :total="pagination.total">
        </el-pagination>
    </el-dialog>
</template>
<script>
    import {CompanyUserList, rolesAuthorize} from '@/api'
    import {pagination} from '@/mixins'

    export default {
        name: 'addMenu',
        mixins: [pagination],
        props: {
            personnelVisible: {
                type: Boolean,
                default: false,
            },
            companyId: {
                type: Number,
                default: 0,
            },
            role_id: {
                type: Number,
                default: 0,
            }
        },
        data() {
            return {
                loading: false,
                tableHeight: 600,
                tableData: [],
                keyWord: {
                    name: '',
                    phone: '',
                    email: '',
                }
            }
        },
        created() {
            // this.tableHeight = getTableHeight(255)
        },
        mounted() {
            if (this.companyId !== 0) {
                this.loading = true
                this.getTableData()
            }
            // window.onresize = () => {
            //     if (this.resizeTimer) {
            //         clearTimeout(this.resizeTimer)
            //     }
            //     //开启定时器，节流函数
            //     this.resizeTimer = setTimeout(() => {
            //         //将计算的table高度赋值给table
            //         this.tableHeight = getTableHeight(255)
            //         //清除定时器
            //         this.resizeTimer = null
            //     }, 100)
            // }
        },
        methods: {
            handleClickSearch() {
                this.pagination.pageNum = 1
                this.getTableData()
            },

            handleClickReset() {
                this.keyWord.name = ''
                this.keyWord.phone = ''
                this.keyWord.email = ''
                this.pagination.pageNum = 1
                this.getTableData()
            },
            //取消事件
            handleClickCancel() {
                //关闭对话框
                this.$emit('update:personnelVisible', false)
            },
            //获取详情
            getTableData() {
                CompanyUserList({
                    company_id: this.companyId,
                    name: this.keyWord.name,
                    phone: this.keyWord.phone,
                    email: this.keyWord.email,
                    page: this.pagination.pageNum,
                    pageSize: this.pagination.pageSize,
                }).then(res => {
                    if (res.code === 200) {
                        const {
                            data,
                            total
                        } = res.data
                        this.tableData = data
                        this.pagination.total = total
                    }
                    this.loading = false
                })
            },

            handleSizeChange(val) {
                this.pagination.pageNum = 1
                this.pagination.pageSize = val
                this.getTableData()
            },

            handleCurrentChange(val) {
                this.pagination.pageNum = val
                this.getTableData()
            },

            handleClickAuth(user_id) {
                rolesAuthorize({
                    user_id,
                    role_id: this.role_id,
                    company_id: this.companyId
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success(res.message)
                        this.getTableData()
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }
        },

    }
</script>
<style lang="scss" scoped>

</style>
